
import { Component, Vue } from 'vue-property-decorator';
import MaintenanceCheck from '@/components/MaintenanceCheck.vue';
import CompleteCheck from '@/components/CompleteCheck.vue';
import ModalApiError from '@/components/ModalApiError.vue';
import ModalOrientation from '@/components/ModalOrientation.vue';

@Component({
  components: {
    MaintenanceCheck,
    CompleteCheck,
    ModalApiError,
    ModalOrientation
  }
})
export default class Root extends Vue {
  public created(): void {
    // 一部のsafriではブラウザバック時に白画面になる問題があるため、scrollRestorationをmanualに設定
    history.scrollRestoration = 'manual';

    if (this.$route.name === 'launch') {
      // 最初のページでは全ての情報をリセット
      this.$store.dispatch('clearState');
      // リクエストトークンを記録しておく
      this.$store.commit('auth/storeRequestURL', { requestURL: location.href });
      this.$store.commit('auth/storeRequestToken', { requestToken: this.$route.query.t || '' });
    }

    // i18n 初期化処理
    const queryLocale: string | (string | null)[] | undefined = this.$route.query.locale;
    if (typeof queryLocale === 'string') this.$store.dispatch('i18n/setLocaleWithi18n', { locale: queryLocale });
    this.$store.dispatch('i18n/setDefaultLocale');
  }
}
